import { z } from 'zod';

export function canParseAsUrl(url: string) {
  try {
    if (typeof URL.canParse === 'function') {
      return URL.canParse(url);
    }
    new URL(url);
    return true;
  } catch {
    return z.string().url().safeParse(url).success;
  }
}

export function parseUrl(url: string) {
  return canParseAsUrl(url) ? new URL(url) : null;
}

export function getHost(url: string) {
  if (!canParseAsUrl(url)) return url;

  return new URL(url).host;
}
